import { Alert } from "@zapier/design-system";

import styles from "./ZapNotAvailable.module.css";

export function ZapNotAvailable() {
  return (
    <div className={styles.sectionWrapper}>
      <Alert status="error">
        {"This Zap either no longer exists or you don't have access to it."}
      </Alert>
    </div>
  );
}
